import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.FAVORITES_PATH,
	name: routeList.FAVORITES_NAME,
	component: () => import('@/views/Favorites')
}]
